export default __webpack_public_path__ + "static/media/10.11e2f235.png";